/**
 * Graph
 * @class
 */
 import { Utilities } from '../utilities/utilities.class';
import { GraphFilters } from './graph-filters.class';

 export class GraphNotVat extends GraphFilters {
     /**
      * @param {String} baseUrl [url to get graph]
      */
     private static baseUrl = 'v3/baskets/dashboard';
     private static topStaffUrl = 'v3/baskets/top-staff';
     private static topItemUrl = 'v3/baskets/top-item-sales';
     private static topTagUrl = 'v3/baskets/top-tag-sales';

     private static branchUrl = 'v3/branches';

     /**
      * @param {String} searchParams [searchParams for get By]
      */
     private static searchBranch = 'branch';
     /**
      * @param {String} searchParams [searchParams for get By]
      */
     private static searchClient = 'client';
     /**
      * @param {String} searchParams [searchParams for get By]
      */
     private static searchStart = 'start';
     /**
      * @param {String} searchParams [searchParams for get By]
      */
     private static searchEnd = 'end';
     /**
      * @param {String} searchParams [searchParams for get By]
      */
     private static searchMode = 'mode';

     /**
      * @TODO: Remove in the future
      * @param {string} searchExtra [fixed param for date format @default date]
      */
     private static searchExtra = 'datetype';

     regCustomers: string;
     newCustomers: string;
     comparedNewCustomers: string;
     newCustomersPercentage: number;
     notRegCustomers: string;
     newRegCustomers: string;
     comparedCustomers: string;
     customersPercentage: number;
     returnCustomers: string;
     totalRevenue: string;
     comparedTotalRevenue: string;
     totalRevenuePercentage: number;
     returned: string;
     returnedPercentage: number;
     totalTransactions: string;
     graph: any[];
     lastSales: any[];
     sharedSales: any[];
     totalCardTipsAmount: string;
     totalCashTipsAmount: string;
     averageItems: string;
     comparedAverageItem: string;
     averageItemPercentage: number;
     averageRevenue: string;
     comparedAverageRevenue: string;
     averageRevenuePercentage: number;
     transactions: string;
     pureGraph: any[] = [];
     averagePerGuest: number;
     comparedTransactions: string;
     comparedTransactionsPercentage: number;
     comparedStart: string;
     comparedEnd: string;
     totalRevenueExclGiftsVouchers: string;
     revenueByVatPercentage: Array<{ taxAccount: string; revenue: string; vat: string }> = [];
     private graphSumDate: any[] = [];
     private graphTotalAmount: any[] = [];
     private graphDates: any[] = [];
     private currency: string;

     constructor(data: any, currency: string) {
         super();
         if (data) {
           this.currency = currency;
           // Average Item section
           this.averageItems = new Utilities().formatMoney(data.average_item, currency);
           this.comparedAverageItem = new Utilities().formatMoney(data.compared_period_average_item, currency);
           this.averageItemPercentage = data.average_item_percentage;

           // Average Revenue Section
           this.averageRevenue = new Utilities().formatMoney(String(data.average_revenue_excl_vat), currency);
           this.comparedAverageRevenue = new Utilities().formatMoney(String(data.compared_period_average_revenue_excl_vat), currency);
           this.averageRevenuePercentage = data.average_revenue_percentage;
           this.returned = new Utilities().formatMoney(data.returned_excl_vat, currency);
           this.returnedPercentage = data.returns_percentage_excl_vat;

           // Customers Section
           this.regCustomers = new Utilities().formatMoney(data.customers, currency);
           this.newCustomers = new Utilities().formatMoney(data.new_customers, currency);
           this.comparedNewCustomers = new Utilities().formatMoney(data.compared_period_new_customers, currency);
           this.newCustomersPercentage = data.new_customers_percentage;
           this.newRegCustomers = String(data.new_registered).indexOf('.') !== -1 ?
            new Utilities().formatMoney(data.new_registered, currency) : String(data.new_registered);
            this.comparedCustomers = new Utilities().formatMoney(data.compared_period_customers, currency);
           this.customersPercentage = data.customers_percentage;
           this.returnCustomers = String(data['returns %']).indexOf('.') !== -1 ?
            new Utilities().formatMoney(data['returns %'], currency) : String(data['returns %']);
           this.notRegCustomers = new Utilities().formatMoney(data.not_registered, currency);

           // Total Revenue Section
           this.totalRevenue = new Utilities().formatMoney(String(data.total_revenue_excl_vat), currency);
           this.comparedTotalRevenue = new Utilities().formatMoney(String(data.compared_period_total_revenue_excl_vat), currency);
           this.totalRevenuePercentage = data.total_revenue_percentage_excl_vat;
           this.totalRevenueExclGiftsVouchers = new Utilities().formatMoney(String(data.total_revenue_excl_gifts_vouchers), currency);

           // Transaction Section
           this.totalTransactions = new Utilities().formatMoney(data.total_number, currency);
           this.transactions = data.transactions;
           this.comparedTransactions = data.compared_period_transactions;
           this.comparedTransactionsPercentage = data.transactions_percentage;

           // Graph Section
           this.graph = this.getGraph(data.graph);
           this.sharedSales = this.getShares(data.shares, data.shares_revenue);
           this.totalCardTipsAmount = new Utilities().formatMoney(String(data.total_card_tips_amount), currency);
           this.totalCashTipsAmount = new Utilities().formatMoney(String(data.total_cash_tips_amount), currency);
           this.pureGraph = data.graph;

           // Revenue breakdown by VAT percentage.
           this.revenueByVatPercentage = this.getRevenueByVatPercentage(data.revenue_by_vat_percentage);

           // Guest Section
           this.averagePerGuest = data.avg_per_guest_excl_vat;

           // Compare Dates
           this.comparedStart = data.compared_period_start || '';
           this.comparedEnd = data.compared_period_end || '';

           this.graphMode = data.graph_mode;
         }
     }

     static get URL() {
         return this.baseUrl;
     }

     static get URLBranch() {
         return this.branchUrl;
     }

     static get URLTopStaff() {
         return this.topStaffUrl;
     }

     static get URLTopItem() {
         return this.topItemUrl;
     }

     static get URLTopTag() {
         return this.topTagUrl;
     }

     static get searchBranchParam() {
         return this.searchBranch;
     }

     static get searchClientParam() {
         return this.searchClient;
     }

     static get searchStartParam() {
         return this.searchStart;
     }

     static get searchEndParam() {
         return this.searchEnd;
     }

     static get searchModeParam() {
         return this.searchMode;
     }

     static get searchExtraParam() {
       return this.searchExtra;
     }

     /**
      * getGraph
      * @function
      * @description [get Graph Data formated]
      * @param {Array<Object>} Graph
      * @return {Array<number>} Data
      */
     private getGraph(graph: Object[]): number[] {
         const Data: number[] = [];
         if (graph) {
             graph.forEach(
                 value => {
                   this.graphDates.push(value['sumdate']);
                   this.graphSumDate.push(value['sumdate']);
                   this.graphTotalAmount.push(value['total_amount_excl_vat']);
                 });
         }
         return Data;
     }

     get graphLabelHours() {
       return this.graphDates;
     }

     get graphDate() {
       return this.graphSumDate;
     }

     get graphData() {
       return this.graphTotalAmount;
     }

     /**
      * getShares
      * @function
      * @description [Get Shares]
      * @param {array} data [data shares]
      * @param {array} dataRevenue [data revenue]
      * @returns {Object[]} [Array of Objects]
      */
     private getShares(dataShare: any[], dataRevenue: any[]): any[] {
       const result: any[] = [];
       if (dataShare && dataRevenue) {
           if (dataShare.length > 0 && dataRevenue.length > 0) {
               dataShare.forEach((item, index) => {
                   const perc = new Utilities().formatMoney(item.share_percent, this.currency);
                   const amo = new Utilities().formatMoney(dataRevenue[index].share_amount_excl_vat, this.currency);
                   result.push({
                       type: item.type, percent: perc,
                       amount: amo
                   });
               });
           }
       }
       return result;
     }

     /**
     * Parse revenue_by_vat_percentage into per‑VAT‑percentage rows with revenue excl. VAT (vat_percentage in basis points, totals in cents/øre).
      */
     private getRevenueByVatPercentage(rows: any[] | undefined): Array<{ taxAccount: string; revenue: string; vat: string }> {
       const result: Array<{ taxAccount: string; revenue: string; vat: string }> = [];
       if (!rows || rows.length === 0) { return result; }
       rows.forEach((row: any) => {
         const vatPct = parseFloat(row.vat_percentage) / 100;
         const taxAccount = `${vatPct}%`;
         const totalInclVat = parseFloat(row.total_incl_vat) / 100;
         const totalVat = parseFloat(row.total_vat) / 100;
         const totalExclVat = totalInclVat - totalVat;
         const revenue = new Utilities().formatMoney(String(totalExclVat), this.currency);
         const vat = new Utilities().formatMoney(String(totalVat), this.currency);
         result.push({ taxAccount, revenue, vat });
       });
       return result;
     }

 }
